import { useState, useEffect } from 'react';
import { Card, CardContent } from '../../ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../ui/table';
import Pagination from '../../ui/pagination';
import { Loader2 } from 'lucide-react';
import { userService } from '../../../_services';

function TieredCommissionTable({ searchText, selectedMonth, onRowClick }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageOfItems, setPageOfItems] = useState([]);

  useEffect(() => {
    if (selectedMonth) {
      fetchData();
    }
  }, [selectedMonth]);

  const fetchData = async () => {
    setLoading(true);
    try {
      // Parse month and year from selectedMonth (format: "month,year")
      const [month, year] = selectedMonth.split(',');
      
      // Get user credentials
      const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
      const [userId, userName] = Usermeta_Data.split(':');
      
      const response = await userService.SecondaryCommTracking_Tier_NonTier(userId, userName, month, year);
      setData(response || []);
    } catch (error) {
      console.error('Error fetching tiered commission data:', error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const filteredData = searchText
    ? data.filter(item => 
        item.distributorName?.toLowerCase().includes(searchText.toLowerCase()) ||
        item.emailId?.toLowerCase().includes(searchText.toLowerCase())
      )
    : data;

  const displayData = searchText ? filteredData : pageOfItems;

  return (
    <Card>
      <CardContent className="p-0">
        {loading ? (
          <div className="flex justify-center items-center p-12">
            <Loader2 className="h-8 w-8 animate-spin text-brand-accent" />
          </div>
        ) : (
          <>
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Distributor Name</TableHead>
                  <TableHead>Email Address</TableHead>
                  <TableHead>Direct</TableHead>
                  <TableHead>Tiered</TableHead>
                  <TableHead>Override</TableHead>
                  <TableHead>Secondary Override</TableHead>
                  <TableHead>Total</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {displayData.length > 0 ? (
                  displayData.map((row, index) => (
                    <TableRow 
                      key={index}
                      className="cursor-pointer hover:bg-gray-50"
                      onClick={() => onRowClick(row, selectedMonth)}
                    >
                      <TableCell>{row.distributorName}</TableCell>
                      <TableCell>{row.emailId}</TableCell>
                      <TableCell>${row.directComm?.toFixed(2) || '0.00'}</TableCell>
                      <TableCell>${row.tiredComm?.toFixed(2) || '0.00'}</TableCell>
                      <TableCell>${row.subDistComm?.toFixed(2) || '0.00'}</TableCell>
                      <TableCell>${row.parentSubDistComm?.toFixed(2) || '0.00'}</TableCell>
                      <TableCell className="font-semibold">
                        ${row.totalCommission?.toFixed(2) || '0.00'}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} className="text-center text-gray-500 py-8">
                      No records found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
            
            {!searchText && filteredData.length > 0 && (
              <div className="p-4 border-t">
                <Pagination 
                  items={filteredData}
                  onChangePage={setPageOfItems}
                  searchlength={searchText}
                />
              </div>
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
}

export default TieredCommissionTable;
